


export default {
    id:"sendRequest",
    type:"(url:string,options:Object):Promise<Response>",
    description:"a replacement to the fetch-api as it's known to be problematic",
    params:[
        {
            name:"url",
            type:"string",
            description:"request url",
        },
        {
            name:"options",
            type:"object",
            props:[
                {
                    name:"method",
                    type:"string",
                    description:`default to <span>GET</span>`,
                },
                {name:"headers",type:"object"},
                {
                    name:"body",type:"any",
                    description:"if the body is not a string, it's automatically stringified",
                },
                {
                    name:"timeout",type:"number",
                    description:`
                        request timeout. If the request is not fulfilled in the specified time, it's automatically
                        rejected and the promise catch error will contain a property <b>"timeout"</b> set to true in that case.
                    `,
                },
                {
                    name:"credentials",
                    type:"boolean",
                    description:"default to false",
                },
            ],
        },
    ],
}
